import {StyleSheet} from 'react-native';

import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  WeightTileGraphLabel: {
    fontSize: 12,
    fontWeight: '400',
    fontFamily: 'OpenSans',
    color: alto,
  },
});
